import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import NameAndStatus from '@blade-sxp/task-management/components/name-status.vue';
import DeviceDarwer from '@blade-sxp/task-management/components/deviceDarwer/index.vue';
import ValidTime from '@blade-sxp/task-management/components/valid-time1.vue';
import AlarmLevel from '@blade-sxp/task-management/components/alarm-level.vue';
import FrequencyAndThreshold from '@blade-sxp/task-management/components/frequency-threshold.vue';
import ButtonBox from '@blade-sxp/task-management/components/button-box.vue';
import { DeviceIdDataModule } from '@blade-sxp/task-management/store/deviceIdData';
import { isEmpty, cloneDeep } from 'lodash';
import { postTask, updateTask, getTaskDetail } from '@blade-sxp/task-management/api/creat-task/index';
import { plotMap } from '@blade-sxp/task-management/components/deviceDarwer/plotConfig';
import ConfidenceBox from '@blade-sxp/task-management/components/confidence.vue';
import OpenTime from '@blade-sxp/task-management/components/open-time.vue';
import TaskNote from '@blade-sxp/task-management/components/task-note.vue';
const Service = {
    postTask,
    updateTask,
    getTaskDetail,
};
let CrowdRetrograde = class CrowdRetrograde extends Vue {
    taskType = '';
    name = '';
    status = 'ENABLE';
    effectivePeriod = 'PERMANENT';
    effectiveDates = {
        start: '',
        end: '',
    };
    effectiveTimes = [{ start: '', end: '' }];
    dayOfWeeks = [];
    alertInterval = 600;
    type = 'add';
    id = '';
    isError = false;
    isDetail = false;
    loading = true;
    level = 'CRITICAL';
    disableRight = false;
    isReady = false;
    idealList = [
        { type: this.$t('exposeConfidence'), value: 66, codeType: 'exposeConfidence' },
        { type: this.$t('overFillConfidence'), value: 66, codeType: 'overFillConfidence' },
        { type: this.$t('trashBinUncoverConfidence'), value: 66, codeType: 'trashBinUncoverConfidence' },
    ];
    titleList = {
        leftTitle: this.$t('taskType'),
        rightTitle: this.$t('confidence'),
    };
    trashDetectThreshold = {};
    openTime = '300';
    remark = '';
    get formData() {
        const { name, openTime, effectivePeriod, effectiveDates, effectiveTimes, dayOfWeeks, isReady, alertInterval, idealList } = this;
        return {
            name,
            effectivePeriod,
            effectiveDates,
            effectiveTimes,
            dayOfWeeks,
            isReady,
            alertInterval,
            idealList,
            openTime,
        };
    }
    init() {
        const { type, id, taskType } = this.$route.query;
        this.type = type;
        this.taskType = taskType;
        this.id = id;
        this.isDetail = type === 'detail';
        if (this.type === 'add') {
            this.loading = false;
        }
        else {
            if (this.isDetail) {
                this.disableRight = false;
            }
            this.getData();
        }
    }
    async validForm(val) {
        if (this.isDetail) {
            return;
        }
        if (!this.isReady) {
            this.disableRight = true;
            return;
        }
        for (let i = 1; i <= 5; i++) {
            if (this.$refs['ruleForm' + i]) {
                let res = await this.$refs['ruleForm' + i].isValidate();
                if (!res) {
                    this.disableRight = true;
                    return;
                }
            }
        }
        const res = val.idealList.find((item) => {
            return item.value === '';
        });
        if (res?.value === '') {
            this.disableRight = true;
            return;
        }
        this.disableRight = false;
    }
    mounted() {
        const taskType = this.$route.query.taskType;
        if (taskType) {
            this.taskType = taskType;
        }
    }
    clickRightButton() {
        if (this.type === 'detail') {
            const url = this.$route.path;
            this.$router.push({ path: url, query: { type: 'update', taskType: this.taskType, id: this.id } });
            this.$route.meta.title = this.$route.meta.title.replace('look', 'edit');
        }
        else {
            this.submit();
        }
    }
    submit() {
        let taskStatus = '';
        if (this.type === 'update') {
            if (this.isError && this.status === 'DISABLE') {
                taskStatus = 'DISABLE';
            }
            else if (this.isError && this.status === 'ENABLE') {
                taskStatus = 'ERROR';
            }
            else {
                taskStatus = this.status;
            }
        }
        else {
            taskStatus = this.status;
        }
        const effectiveTimes = [];
        if (this.effectivePeriod === 'CUSTOMIZE') {
            this.effectiveTimes.forEach((item) => {
                effectiveTimes.push({ start: item.effectiveTimes[0], end: item.effectiveTimes[1] });
            });
        }
        const countUnitEnum = 'PERCENT';
        this.idealList.map((item) => {
            this.trashDetectThreshold[`${item.codeType}`] = { countUnitEnum: countUnitEnum, value: item.value };
        });
        const params = {
            taskName: this.name,
            remark: this.remark,
            taskStatus: taskStatus,
            taskType: this.taskType,
            alarmConfig: {
                enable: true,
                notifyConfig: {
                    enabledAlarmLevels: [this.level],
                    frequency: {
                        unit: 'SECOND',
                        value: this.alertInterval,
                    },
                },
                thresholdConfigs: [
                    {
                        effectivePeriod: this.effectivePeriod,
                        dayOfWeeks: this.dayOfWeeks,
                        effectiveTimes: this.effectivePeriod === 'PERMANENT' ? [] : effectiveTimes,
                        effectiveDates: this.effectivePeriod === 'PERMANENT' ? [] : [this.effectiveDates],
                        trashDetectThreshold: { ...this.trashDetectThreshold, trashBinUncoverTime: { value: this.openTime, unit: 'SECOND' } },
                    },
                ],
            },
            deviceTaskConfigs: this.fromDataDeviceConfig(),
        };
        if (this.type === 'add' || this.type === 'copy') {
            Service.postTask(params).then((res) => {
                this.$message.success(`${this.$t('common.success')}`);
                this.$router.push('/tasklist');
            });
        }
        else {
            Service.updateTask({ taskId: this.id, ...params }).then((res) => {
                this.$message.success(`${this.$t('common.success')}`);
                this.$router.push('/tasklist');
            });
        }
    }
    fromDataDeviceConfig() {
        const config = [];
        let device = DeviceIdDataModule.deviceIdRequestParams;
        let requestMap = new Map();
        requestMap = cloneDeep(device);
        const incidentType = plotMap.get(this.taskType).incidentType;
        if (!isEmpty(requestMap) && !isEmpty(incidentType)) {
            requestMap.forEach((item) => {
                const { zoneId, deviceId, titleList } = item;
                let rawRoi = [];
                if (!isEmpty(titleList)) {
                    titleList.forEach((item) => {
                        if (item.type === 'ROI') {
                            item.data.forEach((item) => {
                                const { vertices, id } = item;
                                vertices.shift();
                                rawRoi.push({
                                    rawRoi: {
                                        vertices,
                                        id: this.taskId(),
                                        name: id,
                                    },
                                });
                            });
                        }
                    });
                }
                let data = {
                    trashDetectConfig: {
                        roiMappings: rawRoi,
                    },
                    zoneId,
                    deviceId,
                    incidentType,
                    roiData: JSON.stringify(device.get(deviceId)),
                };
                config.push(data);
            });
        }
        return config;
    }
    taskId() {
        const num = Math.random() * 100000;
        return Math.round(num);
    }
    cancel() {
        if (this.type === 'detail') {
            this.$router.push('/tasklist');
        }
        else {
            this.$confirm(`${this.$t('cancelSubmitTip')}`, `${this.$t('tip')}`, {
                confirmButtonText: `${this.$t('confirm')}`,
                cancelButtonText: `${this.$t('cancel')}`,
                cancelButtonClass: 'cancel-roi-tip',
                confirmButtonClass: 'confirm-roi-tip',
                customClass: 'task-confirm',
            })
                .then(() => {
                this.$router.push('/tasklist');
            })
                .catch(() => { });
        }
    }
    getData() {
        Service.getTaskDetail(Number(this.id))
            .then(({ name, status, remark, alarmConfig: { thresholdConfigs, notifyConfig }, deviceTaskConfigs }) => {
            this.name = name;
            this.remark = remark;
            if (status === 'ERROR') {
                this.isError = true;
                this.status = 'ENABLE';
            }
            else {
                this.status = status;
            }
            if (thresholdConfigs) {
                const { dayOfWeeks, effectiveDates, effectivePeriod, effectiveTimes, trashDetectThreshold } = thresholdConfigs[0];
                this.dayOfWeeks = dayOfWeeks;
                this.effectivePeriod = effectivePeriod;
                if (this.effectivePeriod !== 'PERMANENT') {
                    this.effectiveDates = effectiveDates[0];
                    this.effectiveTimes = effectiveTimes.map((item) => {
                        return { ...item, effectiveTimes: [item.start, item.end] };
                    });
                }
                this.alertInterval = notifyConfig?.frequency?.value;
                this.level = notifyConfig?.enabledAlarmLevels[0];
                let arr = [];
                const arrData = cloneDeep(this.idealList);
                this.openTime = trashDetectThreshold['trashBinUncoverTime'].value;
                arrData.forEach((item) => {
                    arr.push({
                        type: `${this.$t(item.codeType)}`,
                        value: trashDetectThreshold[item.codeType].value,
                        codeType: item.codeType,
                    });
                });
                this.idealList = arr;
                if (!isEmpty(deviceTaskConfigs)) {
                    deviceTaskConfigs.forEach((item) => {
                        const roiData = item.roiData;
                        if (!isEmpty(roiData)) {
                            const analysis = JSON.parse(roiData);
                            DeviceIdDataModule.deviceIdRequestParams.set(analysis.id, analysis);
                        }
                    });
                }
            }
        })
            .finally(() => {
            this.loading = false;
        });
    }
};
__decorate([
    Watch('$route', { immediate: true, deep: true })
], CrowdRetrograde.prototype, "init", null);
__decorate([
    Watch('formData', { deep: true, immediate: true })
], CrowdRetrograde.prototype, "validForm", null);
CrowdRetrograde = __decorate([
    Component({
        name: 'CrowdRetrograde',
        components: {
            'st-device-darwer': DeviceDarwer,
            'name-and-status': NameAndStatus,
            'valid-time': ValidTime,
            'alarm-level': AlarmLevel,
            'frequency-and-threshold': FrequencyAndThreshold,
            'button-box': ButtonBox,
            'confidence-box': ConfidenceBox,
            'open-time': OpenTime,
            'task-note': TaskNote,
        },
        i18n: {
            messages: {
                en: {
                    alert: 'Alert Notification',
                    cancelSubmitTip: 'Data will not be saved and exited, are you sure to exit?',
                    tip: 'Title',
                    confirm: 'Confirm',
                    cancel: 'Cancel',
                    exposeConfidence: 'Waste Exposed',
                    overFillConfidence: 'Waste Flowing',
                    trashBinUncoverConfidence: 'Waste Uncovered',
                    detection: 'Waste Detection',
                    confidence: 'Confidence',
                    taskType: 'Type',
                    openTimeTitle: 'Lid Opening Time',
                },
                zh: {
                    alert: '告警通知',
                    cancelSubmitTip: '数据将不会保存并退出，确定退出吗？',
                    tip: '提示',
                    confirm: '确定',
                    cancel: '取消',
                    exposeConfidence: '垃圾暴露',
                    overFillConfidence: '垃圾满溢',
                    trashBinUncoverConfidence: '垃圾桶盖打开',
                    detection: '垃圾检测',
                    confidence: '置信度',
                    taskType: '类型',
                    openTimeTitle: '盖子打开时间阈值',
                },
            },
        },
    })
], CrowdRetrograde);
export default CrowdRetrograde;
